import type { Project, CreateProjectPayload, GetProjectsParams, PaginatedProjectsResponse } from '@/interfaces/projects.interface';
import api from './base.api';

export const getProjects = async (params?: GetProjectsParams) => {
  const response = await api.get<PaginatedProjectsResponse>(`/projects`, {
    params,
  });
  return response.data;
};

export const getProjectDetailsById = async (projectId: string) => {
  return api.get<Project>(`/projects/${projectId}`);
};

export const createProject = async (payload: CreateProjectPayload) => {
  const response = await api.post<Project>('/projects', payload);
  return response.data;
};

export const deleteProject = async (projectId: string, projectName?: string) => {
  const response = await api.delete<void>(`/projects/${projectId}`, {
    params: projectName ? { project_name: projectName } : undefined,
  });
  return response.data;
};
